import {
  LitElement,
  html
} from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import AccordionToggleStyle from './style.js';
import ButtonClearStyle from '../Common/ButtonClearStyle.js';
import dedent from '../../util/dedent.js';
import LdsIcon from '../LdsIcon/index.js';

export class LdsAccordionToggle extends LitElement {
  static get styles() {
    return [ButtonClearStyle, AccordionToggleStyle];
  }

  static properties = {
    isOpen: { type: Boolean },
    accordionId: { type: String },
    iconOpenLabel: { type: String },
    iconClosedLabel: { type: String },
  };

  constructor() {
    super();
    this.isOpen = false;
    this.accordionId = undefined;
    this.iconOpenLabel = 'Collapse accordion';
    this.iconClosedLabel = 'Expand accordion';
  }

  /**
   * Lit lifecycle event https://lit.dev/docs/components/lifecycle/
   * Need to run this for accordions that are open initially
   */
  connectedCallback() {
    super.connectedCallback();
    this.setAccordionOpenHeight();
  }

  handleToggle() {
    this.isOpen = !this.isOpen;
    this.setAccordionOpenHeight();
  }

  setAccordionOpenHeight() {
    if (!this.accordionId) {
      // eslint-disable-next-line
      console.error(dedent`
        LdsAccordionToggle - Error
        Prop 'accordionId' must be set for accordion to function correctly.
      `);
    }

    const accordion = document.getElementById(this.accordionId);
    const accordionBody = document.querySelector(`#${this.accordionId} .lds-accordion-body`);

    if (this.isOpen) {
      accordion.classList.add('open');
      accordionBody.style.maxHeight = `${accordionBody.scrollHeight}px`;
    } else {
      accordion.classList.remove('open');
      accordionBody.style.maxHeight = 0;
    }
  }

  render() {
    return html`<div
      class="lds-accordion-toggle ${classMap({ open: this.isOpen })}"
    >
      <button
        @click=${this.handleToggle}
        class="lds-button-clear-style toggle-btn"
        aria-expanded=${this.isOpen}
      >
        <slot></slot>
        <lds-icon
          label="${this.isOpen ? this.iconOpenLabel : this.iconClosedLabel}"
          class="lds-accordion-toggle-icon"
          name="CaretCircleDownFill"
        ></lds-icon>
      </button>
    </div>`;
  }
}

export function defineComponent() {
  if (!window.customElements.get('lds-accordion-toggle')) window.customElements.define('lds-accordion-toggle', LdsAccordionToggle);
  LdsIcon.defineComponent();
}

export default { LdsAccordionToggle, defineComponent };
